module.exports = __webpack_public_path__ + "img/testimonial-bg-shape.6e0ab198.png";